import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { FaTimesCircle, FaArrowUp, FaArrowLeft, FaTimes, FaCheckCircle, FaUserCheck, FaUser, FaInfoCircle, FaDownload, FaNotesMedical, FaMale, FaTasks, FaMapMarkerAlt, FaCalendarAlt, FaVenusMars, FaHandshake } from 'react-icons/fa';
import { auth } from '../firebase';
import './BuscarVagas.css'; 

import './CuidadoresListagem.css';
import CustomHeader from './CustomHeader';
import { Button, IconButton, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import './ContactModal.css';
import logoGPlay from './google.b20c07ec720bfa73a943.webp';
import perfilImage from './perfil.png';

const BackButton = styled(Button)({
  marginBottom: '20px',
  backgroundColor: '#2A9D8E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#21867A',
  },
  display: 'flex',
  alignItems: 'center',
});

const ModalHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid #ccc',
  paddingBottom: '10px',
  marginBottom: '20px',
});

const ModalTitle = styled('h2')({
  fontSize: '1.5rem',
  color: '#2A9D8E',
});

const ModalContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  lineHeight: '1.6',
});

const IconItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '10px',
  '& svg': {
    marginRight: '8px',
    color: '#2A9D8E',
    fontSize: '1.5rem',
  },
});

const CloseButton = styled(IconButton)({
  color: '#FF4C4D',
  '&:hover': {
    backgroundColor: 'rgba(255, 76, 77, 0.1)',
  },
});

const ContactButton = styled(Button)({
  backgroundColor: '#2A9D8E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#21867A',
  },
  marginTop: '20px',
});

const customStyles = {
  content: {
    top: '150px',
    left: '50%',
    right: 'auto',
    bottom: '40px',
    marginRight: '-50%',
    transform: 'translate(-50%, 0)',
    padding: '20px',
    borderRadius: '10px',
    width: '80%',
    maxHeight: '80%',
    overflowY: 'auto',
    backgroundColor: '#fff',
  },
};

const BuscarVagas = () => {
  const [vagas, setVagas] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [contactModalIsOpen, setContactModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [assinatura, setAssinatura] = useState("Sem Plano");

  const containerRef = useRef(null);
  const navigate = useNavigate();

  const fetchVagas = async () => {
    try {
      console.log("Iniciando a busca de vagas...");

      const vagasSnapshot = await getDocs(collection(db, "anuncios"));
      console.log(`Documentos na coleção 'anuncios' obtidos: ${vagasSnapshot.docs.length}`);

      const vagasList = await Promise.all(
        vagasSnapshot.docs.flatMap(async (docAnuncio) => {
          console.log(`Processando documento com ID: ${docAnuncio.id}`);
          const data = docAnuncio.data();
          console.log("Dados do documento:", data);

          const clienteDocRef = doc(db, 'clientes', docAnuncio.id);
          const clienteDoc = await getDoc(clienteDocRef);
          const clienteData = clienteDoc.exists() ? clienteDoc.data() : {};
          console.log("Dados do cliente:", clienteData);

          const anunciosPromises = data.anuncios.map(async (anuncio) => {
            console.log("Processando anúncio:", anuncio);

            let bairro = "Bairro não informado";
            if (anuncio.cep) {
              bairro = await fetchBairroFromCep(anuncio.cep);
            }
            console.log("Bairro obtido do CEP:", bairro);

            return {
              id: docAnuncio.id,
              ...anuncio,
              name: clienteData.name || "Nome não informado",
              avatar: clienteData.avatar || perfilImage,
              bairro,
            };
          });

          return Promise.all(anunciosPromises);
        })
      );

      const flattenedVagasList = vagasList.flat();
      console.log("Lista de vagas desaninhada:", flattenedVagasList);

      setVagas(flattenedVagasList);
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
    }
  };

  const openContactModal = async () => {
    const tipoDeConta = await fetchTipoDeConta();
    setAssinatura(tipoDeConta);
    setContactModalIsOpen(true);
  };

  const fetchTipoDeConta = async () => {
    const user = auth.currentUser;

    if (user) {
      const cuidadorRef = doc(db, 'cuidadores', user.uid);
      const cuidadorSnap = await getDoc(cuidadorRef);

      if (cuidadorSnap.exists()) {
        return cuidadorSnap.data().tipodeconta || "Sem Plano";
      } else {
        console.log('Nenhum documento encontrado para o cuidador com uid:', user.uid);
        return "Sem Plano";
      }
    } else {
      console.log('Nenhum usuário autenticado.');
      return "Sem Plano";
    }
  };

  const fetchBairroFromCep = async (cep) => {
    if (!cep) {
      console.error("CEP não informado.");
      return "Bairro não informado";
    }

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);

      if (!response.ok) {
        throw new Error("Erro ao buscar informações do CEP");
      }

      const data = await response.json();

      if (data.erro) {
        console.error("CEP não encontrado.");
        return "Bairro não encontrado";
      }

      return data.bairro || "Bairro não informado";
    } catch (error) {
      console.error("Erro ao buscar informações do CEP:", error);
      return "Bairro não encontrado";
    }
  };

  useEffect(() => {
    fetchVagas();
  }, []);

  const openDetailsModal = (vaga) => {
    setModalContent(vaga);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setContactModalIsOpen(false);
  };

  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const renderContentBasedOnAssinatura = () => {
    if (assinatura && assinatura !== "Sem Plano") {
      return (
        <Box textAlign="center">
          <Typography variant="h6" gutterBottom>
            Você é um assinante do plano: "{assinatura}".
          </Typography>
          <Typography variant="body1" gutterBottom>
            Para entrar em contato com os profissionais, você precisa baixar o app:
          </Typography>
          <a href="https://play.google.com/store/apps/details?id=com.carey.appy.CareyAppCuidadores" target="_blank" rel="noopener noreferrer">
            <img src={logoGPlay} alt="Google Play" style={{ width: '220px' }} />
          </a>
        </Box>
      );
    } else {
      return (
        <Box>
          <Typography variant="body1" gutterBottom>
            Para você poder entrar em contato com as vagas e oportunidades, você precisa:
          </Typography>

          <IconItem>
            <FaCheckCircle />
            <Typography variant="h6" component="span" fontWeight="bold">
              Assinar um Plano
            </Typography>
          </IconItem>
          <Typography variant="body2" gutterBottom>
            Você precisa ter um plano de assinatura válido.
          </Typography>
          <ContactButton
            variant="contained"
            fullWidth
            onClick={() => {
              console.log("Botão 'Entrar em Contato' clicado");
              navigate('/minha-conta'); // Redireciona para a página "minha-conta"
            }}
          >
            Assinar um Plano
          </ContactButton>

          <IconItem>
            <FaDownload />
            <Typography variant="h6" component="span" fontWeight="bold">
              Baixar o App
            </Typography>
          </IconItem>
          <Typography variant="body2" gutterBottom>
            Baixe o app para usufruir de todas as funcionalidades que a Carey tem para te oferecer :)
          </Typography>
          <a href="https://play.google.com/store/apps/details?id=com.carey.appy.CareyAppCuidadores" target="_blank" rel="noopener noreferrer">
            <img src={logoGPlay} alt="Google Play" style={{ width: '220px', marginTop: '10px' }} />
          </a>
        </Box>
      );
    }
  };

  return (
    <div className="container" ref={containerRef}>
      <CustomHeader />

      <BackButton fullWidth onClick={() => navigate('/home')}>
        <FaArrowLeft style={{ marginRight: '8px' }} />
        Voltar para Home
      </BackButton>

      {vagas.length > 0 ? (
        <div className="cards-container">
      {vagas.map((vaga, index) => (
        <div key={index} className="card">
          <img
            src={vaga.avatar}
            alt={vaga.name || "Imagem padrão"}
            className="avatar"
          />
          <div className="card-content">
            <h3 className="name">{vaga.name || "Nome não informado"}</h3>
            <p className="details">Função: {vaga.tipoProfissional || "Não informado"}</p>
            <p className="details">Bairro: {vaga.bairro || "Não informado"}</p>

            <button className="button-details" onClick={() => openDetailsModal(vaga)}>
              Detalhes da Vaga
            </button>
            <ContactButton
              variant="contained"
              fullWidth
              onClick={openContactModal}
            >
              Entrar em Contato
            </ContactButton>
          </div>
        </div>
      ))}
    </div>

      ) : (
        <p>Nenhuma vaga disponível no momento.</p>
      )}

  <Modal
  isOpen={modalIsOpen}
  onRequestClose={closeModal}
  style={customStyles}
  contentLabel="Detalhes da Vaga"
>
  <ModalHeader>
    <ModalTitle style={{ color: '#2A9D8E' }}>
      <FaUser /> Detalhes da Vaga
    </ModalTitle>
    <CloseButton onClick={closeModal}>
      <FaTimes size={20} />
    </CloseButton>
  </ModalHeader>

  <ModalContent>
    <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
      <img
        src={modalContent?.avatar || perfilImage}  // Verificação de null para modalContent.avatar
        alt={modalContent?.name || "Imagem padrão"} // Verificação de null para modalContent.name
        style={{ borderRadius: '50%', width: '150px', height: '150px', marginBottom: '20px' }}
      />
      <Typography variant="h5" component="h3">
        {modalContent?.name || "Nome não informado"}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        {modalContent?.tipoProfissional || "Função não informada"}
      </Typography>
    </Box>

    {/* Detalhes da Vaga */}
    <Box mb={2}>
      <Box display="flex" alignItems="center" mb={1}>
        <FaNotesMedical style={{ marginRight: '8px', color: '#2A9D8E' }} />
        <Typography variant="h6">Detalhes da Vaga:</Typography>
      </Box>
      <Typography variant="body1" color="textSecondary">
        {modalContent?.detalhesVaga || "Nenhum detalhe informado"}
      </Typography>
    </Box>

    {/* Informações do Idoso */}
    <Box mb={2}>
      <Box display="flex" alignItems="center" mb={1}>
        <FaMale style={{ marginRight: '8px', color: '#2A9D8E' }} />
        <Typography variant="h6">Informações do Idoso:</Typography>
      </Box>
      <Typography variant="body1" color="textSecondary">
        Gênero: {modalContent?.generoIdoso || "Não informado"}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Necessidade Especial: {modalContent?.necessidadeEspecial ? "Sim" : "Não"}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Comorbidade: {modalContent?.possuiComorbidade ? "Sim" : "Não"}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Medicamentos: {modalContent?.medicacoes && modalContent.medicacoes.length > 0 ? modalContent.medicacoes.join(", ") : "Nenhum"}
      </Typography>
    </Box>

    {/* Tarefas Requeridas */}
    <Box mb={2}>
      <Box display="flex" alignItems="center" mb={1}>
        <FaTasks style={{ marginRight: '8px', color: '#2A9D8E' }} />
        <Typography variant="h6">Tarefas Requeridas:</Typography>
      </Box>
      {modalContent?.tarefas ? Object.entries(modalContent.tarefas).map(([tarefa, realizada]) => (
        realizada && (
          <Typography key={tarefa} variant="body1" color="textSecondary">
            - {tarefa}
          </Typography>
        )
      )) : "Nenhuma tarefa informada"}
    </Box>

    {/* Gênero de Preferência */}
    <Box mb={2}>
      <Box display="flex" alignItems="center" mb={1}>
        <FaVenusMars style={{ marginRight: '8px', color: '#2A9D8E' }} />
        <Typography variant="h6">Gênero de Preferência do Cuidador:</Typography>
      </Box>
      <Typography variant="body1" color="textSecondary">
        {modalContent?.generoPreferencia || "Não informado"}
      </Typography>
    </Box>

    {/* Dia/Início e Horário */}
    <Box mb={2}>
      <Box display="flex" alignItems="center" mb={1}>
        <FaCalendarAlt style={{ marginRight: '8px', color: '#2A9D8E' }} />
        <Typography variant="h6">Dia/Início e Horário:</Typography>
      </Box>
      <Typography variant="body1" color="textSecondary">
        Dia/Início: {modalContent?.selectedDate || "Não informado"}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Horário: {modalContent?.selectedTime || "Não informado"}
      </Typography>
    </Box>

    {/* Endereço Completo */}
    <Box mb={2}>
  <Box display="flex" alignItems="center" mb={1}>
    <FaMapMarkerAlt style={{ marginRight: '8px', color: '#2A9D8E' }} />
    <Typography variant="h6">Localização:</Typography>
  </Box>
  <Typography variant="body1" color="textSecondary">
    Bairro: {modalContent?.enderecoCompleto?.bairro || "Bairro não informado"}
  </Typography>
  <Typography variant="body1" color="textSecondary">
    Cidade: {modalContent?.enderecoCompleto?.cidade || "Cidade não informada"}
  </Typography>
</Box>


    {/* Data e Tipo de Contrato */}
    <Box mb={2}>
      <Box display="flex" alignItems="center" mb={1}>
        <FaHandshake style={{ marginRight: '8px', color: '#2A9D8E' }} />
        <Typography variant="h6">Data e Tipo de Contrato:</Typography>
      </Box>
      <Typography variant="body1" color="textSecondary">
        Data de Criação: {modalContent?.dataCriacao || "Data não informada"}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Tipo de Contrato: {modalContent?.tipoContrato || "Tipo de contrato não informado"}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Diária Tipo: {modalContent?.diariaTipo || "N/A"}
      </Typography>
    </Box>
  </ModalContent>

  <Box mt={4} display="flex" justifyContent="center">
    <Button
      onClick={closeModal}
      style={{
        backgroundColor: '#FF4D4D',
        color: '#fff',
        width: '300px',
        marginTop: '20px',
      }}
    >
      Fechar
    </Button>
  </Box>
</Modal>




      <Modal
        isOpen={contactModalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Entrar em Contato"
      >
        <ModalHeader>
          <ModalTitle>Entrar em Contato</ModalTitle>
          <CloseButton onClick={closeModal}>
            <FaTimes size={20} />
          </CloseButton>
        </ModalHeader>

        <ModalContent>
          {renderContentBasedOnAssinatura()}
        </ModalContent>

        <Box mt={4} display="flex" justifyContent="center">
          <Button
            onClick={closeModal}
            style={{
              backgroundColor: '#FF4D4D',
              color: '#fff',
              width: '300px',
              marginTop: '20px',
            }}
          >
            Fechar
          </Button>
        </Box>
      </Modal>

      <IconButton
        onClick={scrollToTop}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#2A9D8E',
          color: '#fff',
        }}
      >
        <FaArrowUp size={24} />
      </IconButton>
    </div>
  );
};

export default BuscarVagas;



